import { Box } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import { FC, useEffect } from 'react';
import { Outlet } from 'react-router';
import { useStore } from '../../hooks/useStore';
import { BaseAppbar, BaseAppbarProps } from './baseAppbar';

type Props = {
  backgroundColor?: ResponsiveStyleValue<string>;
  hasAppbar?: boolean;
} & BaseAppbarProps;

export type LoadingProps = {
  isLoading?: boolean;
};

export const BasePage: FC<Props> = ({
  backgroundColor = 'background.default',
  hasAppbar = false,
  hideMenuLinks
}) => {
  const { authenticationStore } = useStore();
  useEffect(() => {
    authenticationStore.fetchLanguage();
  }, []);

  return (
    <Box
      sx={{
        height: hasAppbar ? 'calc(100vh - 72px)' : '100vh',
        backgroundColor,
        paddingTop: hasAppbar ? '72px' : 0
      }}
    >
      {hasAppbar && <BaseAppbar hideMenuLinks={hideMenuLinks} />}
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
